//this update login min 5 char and  view password 
import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody, Label, Form, Alert, Input, FormFeedback, InputGroup, InputGroupText } from 'reactstrap';
import lmsLogo from "../../assets/images/lmsLogo.png";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import PropTypes from "prop-types";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import withRouter from 'components/Common/withRouter';

// actions
import { loginUser, socialLogin } from "../../store/actions";
import Loader from 'components/Loader/Loader';
import { postLogin } from 'helpers/fakebackend_helper';
import { toast } from 'react-toastify';


const Login = props => {
  document.title = "Login | LMS - Skill Serve";

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const login = useSelector(state => state.login);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Please enter a valid email address")
        .required("Please enter your email"),
      password: Yup.string()
        .min(5, "Password must be at least 5 characters")
        .required("Please enter your password"),
    }),
    onSubmit: async (values) => {
      handleSubmit(values);
    }
  });

  const handleSubmit = async (values) => {
    try {
      setLoader(true);
      const res = await postLogin({
        email: values.email,
        password: values.password,
      })

      if (res?.success) {
        toast.success(res?.message);
        localStorage.setItem("authUser", JSON.stringify(res));
        // navigate("/dashboard");
        window.location.href = "/dashboard"
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setLoader(false);
    }
  };

  const selectLoginState = (state) => state.Login;
  const LoginProperties = createSelector(
    selectLoginState,
    (login) => ({
      error: login.error
    })
  );

  const {
    error
  } = useSelector(LoginProperties);

  const signIn = type => {
    dispatch(socialLogin(type, props.router.navigate));
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        {loader && <Loader />}
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <CardBody className="pt-0">
                  <h3 className="text-center mt-5 mb-2">
                    <Link to="/" className="d-block auth-logo">
                      <img src={lmsLogo} alt="" height="140" className="auth-logo-dark" />
                    </Link>
                  </h3>

                  <div className="p-3">
                    <h4 className="text-muted font-size-18 mb-1 text-center">SKILLSERVE</h4>
                    <p className="text-muted text-center">Sign in to continue.</p>
                    
                    <Form
                      className="form-horizontal mt-4"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      {error && <Alert color="danger">{error}</Alert>}
                      
                      {/* Email Field */}
                      <div className="mb-3">
                        <Label htmlFor="email">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={validation.touched.email && validation.errors.email}
                          disabled={loader}
                        />
                        {validation.touched.email && validation.errors.email && (
                          <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                        )}
                      </div>
                      
                      {/* Password Field with Toggle Visibility */}
                      <div className="mb-3">
                        <Label htmlFor="password">Password</Label>
                        <InputGroup>
                          <Input
                            name="password"
                            value={validation.values.password || ""}
                            type={passwordVisible ? "text" : "password"}
                            placeholder="Enter Password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={validation.touched.password && validation.errors.password}
                            disabled={loader}
                            className="border-end-0"
                          />
                          <InputGroupText 
                            className="bg-white cursor-pointer"
                            onClick={togglePasswordVisibility}
                            style={{ 
                              cursor: 'pointer',
                              borderLeft: 'none',
                              borderTopRightRadius: '0.25rem',
                              borderBottomRightRadius: '0.25rem'
                            }}
                            title={passwordVisible ? "Hide password" : "Show password"}
                          >
                            {passwordVisible ? (
                              <i className="mdi mdi-eye-off text-secondary"></i>
                            ) : (
                              <i className="mdi mdi-eye text-secondary"></i>
                            )}
                          </InputGroupText>
                        </InputGroup>
                        {validation.touched.password && validation.errors.password && (
                          <FormFeedback type="invalid" className="d-block mt-1">
                            {validation.errors.password}
                          </FormFeedback>
                        )}
                        <small className="text-muted mt-1 d-block">
                          Click the eye icon to {passwordVisible ? 'hide' : 'show'} password
                        </small>
                      </div>
                      
                      {/* Remember Me and Login Button */}
                      <Row className="mb-3 mt-4">
                        <div className="col-6">
                          <div className="form-check">
                            <input 
                              type="checkbox" 
                              className="form-check-input" 
                              id="rememberMe" 
                              disabled={loader}
                            />
                            <label className="form-check-label" htmlFor="rememberMe">
                              Remember me
                            </label>
                          </div>
                        </div>
                        <div className="col-6 text-end">
                          <button
                            className={`btn w-md waves-effect waves-light ${loader ? 'btn-secondary' : 'btn-primary'}`}
                            type="submit"
                            disabled={loader}
                          >
                            {loader ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Logging in...
                              </>
                            ) : (
                              'Log In'
                            )}
                          </button>
                        </div>
                      </Row>
                      
                      {/* Additional Links */}
                      <div className="mt-3 text-center">
                        <Link to="/forgot-password" className="text-muted me-3">
                          <i className="mdi mdi-lock me-1"></i> Forgot password?
                        </Link>
                        {/* <span className="text-muted">|</span> */}
                        {/* <Link to="/register" className="text-muted ms-3">
                          <i className="mdi mdi-account-plus me-1"></i> Create account
                        </Link> */}
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>

              {/* Footer */}
              <div className="mt-5 text-center">
                <div className="text-muted">
                  <p className="mb-2">
                    Need help? <Link to="/contact" className="text-primary">Contact support</Link>
                  </p>
                  <p className="mb-0">
                    © {new Date().getFullYear()} SkillServe. All rights reserved.
                  </p>
                  <small className="text-muted">
                    Designed By Amass Skill Ventures
                  </small>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};